import { Typography } from '@material-ui/core'
import useStyles from './TextBanner.styles'

interface TextBannerProps {
  headingText: string
}

export function TextBanner({ headingText }: TextBannerProps) {
  const classes = useStyles()

  return (
    <div className={classes.bannerContainer}>
      <Typography className={classes.heading} component="h2" variant="h4">
        {headingText}
      </Typography>
    </div>
  )
}
